/* This is the EMIS in classroom facilities */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 43px"
        width="450px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 350px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្ថានភាព
            </td>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ចំនួន
            </td>
          </tr>
          <tr v-for="(value, row) in roomfac.length" :key="row">
            <td
              style="
                width: 350px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ roomfac[row] }}
            </td>
            <td>
              <numberinput v-model="data[row].dt[0]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { roomfac } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      roomfac: roomfac,
    };
  },
};
</script>

<style scoped>
.number {
  width: 100px;
  text-align: center;
}
.row-data {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
</style>
